// import { useState } from 'react';
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Tab, Tabs } from '@mui/material';
import './sommelier-commission.scss';
import { getSommelierCommissions } from 'src/lib/order/SommelierCommission';
import moment from 'moment';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function SommelierCommission() {
  const [value, setValue] = React.useState(0);
  const [groupby, setGroupby] = React.useState('month');
  const [commissionsByMonth, setCommissionsByMonth] = React.useState<[]>([]);
  const [commissionsByDay, setCommissionsByDay] = React.useState<[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    getSommelierCommissionsAmount(groupby);
  }, []);

  const getSommelierCommissionsAmount = async (groupby: string) => {
    const sommelierCommission = await getSommelierCommissions(groupby);
    if (sommelierCommission.status === 1) {
      if (groupby === 'month') {
        setCommissionsByMonth(sommelierCommission.result?.commissions || []);
      }
      if (groupby === 'day') {
        setCommissionsByDay(sommelierCommission.result?.commissions || []);
      }
      setIsLoading(false);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setIsLoading(true);
    setValue(newValue);
    if (newValue === 0) {
      setGroupby('month');
      getSommelierCommissionsAmount('month');
    } else {
      setGroupby('day');
      getSommelierCommissionsAmount('day');
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <div className="col-12 mt-3 mt-md-4">
        <div className="section-title">
          <h3 className="mb-2 mb-md-3">My Commission</h3>
        </div>
      </div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{ style: { background: '#b25661', height: '4px' } }}
        >
          <Tab label="Monthly Commissions" {...a11yProps(0)} className="headerTabs" />
          <Tab label="Commission by date" {...a11yProps(1)} className="headerTabs" />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className="sommelier-commission">
          <table>
            <tr style={{ borderBottom: '1px solid #D9D9D9' }}>
              <th>Month</th>
              <th>Commission Amount</th>
            </tr>
            {commissionsByMonth.length > 0 && !isLoading ? (
              commissionsByMonth.map((commission: Record<string, any>, index: number) => {
                const { year, month } = commission._id;
                const date = new Date(year, month - 1);
                const formattedDate = moment(date).format("MMMM'YY");
                return (
                  <tr key={index + 'Month'}>
                    <td>{formattedDate}</td>
                    <td>${commission.totalAmount}</td>
                  </tr>
                );
              })
            ) : isLoading ? (
              <tr>
                <td>Loading...</td>
              </tr>
            ) : (
              <tr>
                <td>No Commission Found</td>
              </tr>
            )}
          </table>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className="sommelier-commission">
          <table>
            <tr style={{ borderBottom: '1px solid #D9D9D9' }}>
              <th>Date</th>
              <th>Commission Amount</th>
            </tr>
            {commissionsByDay.length > 0 && !isLoading ? (
              commissionsByDay.map((commission: Record<string, any>, index: number) => {
                const { year, month, day } = commission._id;
                const date = new Date(year, month - 1, day);
                const formattedDate = moment(date).format("DD MMMM'YY");
                return (
                  <tr key={index + 'Date'}>
                    <td>{formattedDate}</td>
                    <td>${commission.totalAmount}</td>
                  </tr>
                );
              })
            ) : isLoading ? (
              <tr>
                <td>Loading...</td>
              </tr>
            ) : (
              <tr>
                <td>No Commission Found</td>
              </tr>
            )}
          </table>
        </div>
      </CustomTabPanel>
    </Box>
  );
}
